import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  placeholder?: string;
  large?: boolean;
}

export default function SearchBar({ placeholder = '搜索女优姓名...', large = false }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className={`relative ${large ? 'max-w-2xl' : 'max-w-md'} mx-auto`}>
        <div className="flex items-center bg-background-50 border border-background-300 rounded-full overflow-hidden focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100 transition-all">
          <div className="pl-4 md:pl-5 w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-search-line text-foreground-400 text-lg"></i>
          </div>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            className={`flex-1 bg-transparent text-foreground-950 placeholder-foreground-400 focus:outline-none px-3 ${
              large ? 'py-3 md:py-4 text-base' : 'py-2.5 text-sm'
            }`}
          />
          <button
            type="submit"
            className={`flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-background-50 font-medium transition-colors cursor-pointer whitespace-nowrap ${
              large ? 'px-6 py-3 md:py-4 text-sm mr-1.5 rounded-full' : 'px-4 py-2 text-xs mr-1 rounded-full'
            }`}
          >
            搜索
          </button>
        </div>
      </div>
    </form>
  );
}